import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';

whenDocumentReady(initModule);
function initModule() {
    let heroesHeight = document.querySelectorAll('[paws-component="noss-hero"].include-header[class*="sizing-"]');
    if (heroesHeight.length) {
        for (let i = 0; i < heroesHeight.length; ++i) {
            let currentHeight = heroesHeight[i].offsetHeight + 'px';
            heroesHeight[i].style.setProperty('height', 'calc(' + currentHeight + ' - var(--paws-completeheader-height))', 'important');
        }
    }
}